import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { RecordController } from 'src/controllers/record.controller'
import { PendingRecordDTO } from 'src/dto/record.dto'

const recordController = new RecordController()

export function useGetRecordById(recordId?: string, params?: { status?: 'Rejeitado' | 'Processado' | 'Pendente' }) {
  const { userFarm: farmId } = useAuth()

  return useQuery<PendingRecordDTO[], Error>({
    queryKey: ['getRecordById', recordId],
    queryFn: () => recordController.getRecordById(farmId!, recordId!, params),
    enabled: !!farmId && !!recordId,
    retry: true,
    staleTime: 0,
    refetchOnWindowFocus: false,
    throwOnError: false
  })
}
